import { render, staticRenderFns } from "./CalculatorsStrength.vue?vue&type=template&id=50e54f64"
import script from "./CalculatorsStrength.vue?vue&type=script&lang=ts"
export * from "./CalculatorsStrength.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports